export class UserLegalEntityAttributesBasicInfo {
    userId: number | undefined;
    legalEntityId: number | undefined;
    legalEntityCompanyName: string | undefined;
    legalEntityFiscalCode: string | undefined;
    delegation: boolean | undefined;
}
